import { inject, Injectable } from '@angular/core';
import { UserStore } from '@stores/user.store';
import { ArtRoute } from '@utils/interfaces';
import { AuthoritiesDTO, RolesDTO } from '@api';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private userStore = inject(UserStore);

  private getUserOrThrow() {
    const user = this.userStore.user();
    if (!user) throw new Error('Cannot check permissions if User undefined.');
    return user;
  }

  hasRole(role: RolesDTO): boolean {
    const user = this.getUserOrThrow();
    return user.roles.includes(role);
  }

  hasAuthority(authorities: AuthoritiesDTO[]): boolean {
    const user = this.getUserOrThrow();
    if (this.hasRole(RolesDTO.ART_ADMIN)) return true;

    if (authorities.length === 0) return true;
    const userAuthorities = user.authorities ?? [];
    return authorities.some((authority) => userAuthorities.includes(authority));
  }

  filterAuthorizedRoutes(routes: ArtRoute[]) {
    return routes.filter((route) => !route.data?.authorities || this.hasAuthority(route.data?.authorities));
  }
}
